<template>
  <base-list-item
    @onSelected="$emit('onSelected', item)"
    @toggleFavoriteState="$emit('toggleFavoriteState2', item)"
    :file="item"
    :teaserUrl="thumbnailUrl"
    :longClickEnabled="false"
    showLocation
  >
  </base-list-item>
</template>

<script>
import videoMixin from './videoMixin';
import BaseListItem from '@/components/listItems/BaseListItem.vue';

export default {
  name: 'VideoListItem',
  props: {
    item: Object,
  },
  mixins: [videoMixin],
  components: {
    BaseListItem,
  },
  mounted() {
    console.debug('thumbnailUrl', this.thumbnailUrl);
  },
  computed: {
    thumbnailUrl() {
      return this.mx_thumbnailUrl(this.item);
    },
    videoUrl() {
      return this.mx_videoUrl(this.item);
    },
  },
};
</script>
